// extracted by mini-css-extract-plugin
export default {"base-container":"BaseImg_base-container__1ijOM","base-container-title":"BaseImg_base-container-title__L+Edk","base-container-img":"BaseImg_base-container-img__nKRrT"};